const Messages = {
    apiError: "Error connecting to API",
    noAccess: "Please contact your administrator if you require additional access.",
    noAccessTitle: "Insufficient permissions",
    statementsUnavailable: "Statements are currently unavailable.<br/><br/>We'll let you know about future updates on statements. Stay tuned!",
    errorInitiatingPayment: "Error initiating payment"
}

export default Messages;